import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { DialogModule } from "./services/dialog/dialog.module";
import { MaterialModule } from "./modules/material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from '@angular/google-maps';
import { LocationModalComponent } from "./components/location-modal/location-modal.component";
import { LocationPickerModalComponent } from "./components/location-picker-modal/location-picker-modal.component";
import { HelpVideoModalComponent } from "./components/help-video-modal/help-video-modal.component";
import { MoneyPipe } from "./pipes/money.pipe";
import { ProductAutocompleteComponent } from "./components/product-autocomplete/product-autocomplete.component";
import { HttpService } from "../../http.service";
import { CompaniesService } from "../admin/companies-page/companies/companies.service";
import { Broadcaster } from "./components/broadcaster.component";
import { DetailItemComponent } from "./components/detail-item/detail-item.component";
import { DetailListComponent } from "./components/detail-list/detail-list.component";
import { ExpenseAutocompleteComponent } from "./components/expense-autocomplete/expense-autocomplete.component";
import { JWTService } from "./services/jwt-parser.service";
import { LocalStorageService } from "./services/local-storage.service";
import { UtilsService } from "./services/utils.service";
import { StickyHeaderDirective } from "./directives/sticky-header.directive";
import { InputTrimDirective } from "./directives/input-trim.directive";
import { StickyFooterDirective } from "./directives/sticky-footer.directive";
import { TimeMaskDirective } from "./directives/time-mask.directive";
import { FileViewModalComponent } from "./components/file-view-modal/file-view-modal.component";
import { RecurrenceComponent } from "./components/recurrence/recurrence.component";
import { InputDecimalComponent } from "./components/input-decimal/input-decimal.component";

@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    DialogModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    GoogleMapsModule
  ],
  declarations: [
    StickyHeaderDirective,
    StickyFooterDirective,
    InputTrimDirective,
    TimeMaskDirective,
    LocationModalComponent,
    LocationPickerModalComponent,
    FileViewModalComponent,
    HelpVideoModalComponent,
    RecurrenceComponent,
    MoneyPipe,
    InputDecimalComponent,
    ProductAutocompleteComponent,
    ExpenseAutocompleteComponent,
    DetailItemComponent,
    DetailListComponent
  ],
  exports: [
    StickyHeaderDirective,
    StickyFooterDirective,
    InputTrimDirective,
    TimeMaskDirective,
    LocationModalComponent,
    LocationPickerModalComponent,
    FileViewModalComponent,
    HelpVideoModalComponent,
    RecurrenceComponent,
    MoneyPipe,
    InputDecimalComponent,
    ProductAutocompleteComponent,
    ExpenseAutocompleteComponent,
    DetailItemComponent,
    DetailListComponent
  ]
})

export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        Broadcaster,
        HttpService,
        UtilsService,
        LocalStorageService,
        JWTService,
        CompaniesService
      ]
    };
  }
}